import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Menu, Layout, Avatar, Dropdown, Button, Modal, Switch, Badge } from 'antd';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import './Header.css';
import { BellFilled, SettingFilled } from '@ant-design/icons';
import { setEnterPrivateTchat } from '../../action/tchat/tchat_actions';
import { store } from '../../index';
import { setLogout, setUserUpdate } from '../../action/authentication/authentication_actions';
import Notification from './component/Notification';

const { Header } = Layout;


const HeaderLayout = ({ user, tchat, app, ...props }) => {
    const [visible, setVisible] = useState(false)
    const [status, setStatus] = useState(user.data?.statusOnline)
    const handleLogout = () => {
        props.dispatch(setLogout())
        props.dispatch(setEnterPrivateTchat({ userConversation: undefined }))
        window.socket.disconnect()
        props.history.push('/login')
    }

    useEffect(() => {
        const backdrop = document.getElementsByClassName('global-layout');
        if (visible) {
            if (backdrop[0]) {
                backdrop[0].classList.add('blur')
            }
        } else {
            if (backdrop[0]) {
                backdrop[0].classList.remove('blur')
            }
        }
    }, [visible])

    useEffect(() => {
        setStatus(prev => !prev)
    }, [user])

    const menu = (
        <Menu className="dropdown-menu-title">
            <div className="option"><span>{user?.data?.name}</span>
                <Button size="small" onClick={() => props.history.push('/profile')}><SettingFilled /></Button>
            </div>
            <Menu.Item>
                <Button onClick={handleLogout}>Se déconnecter</Button>
            </Menu.Item>
        </Menu>
    );

    const notification = (
        <Menu className="dropdown-menu-notifiction">
            <Notification />
        </Menu>
    )

    const handleChangeStatus = () => {
        const statusOnline = store.getState().user?.data?.statusOnline === "online" ? "busy" : "online"
        props.dispatch(setUserUpdate({ statusOnline }))
        window.socket.emit('user-change-status', { id: window.socket.id, statusOnline })
    }

    return (<>
        <Modal
            visible={visible}
            onCancel={() => setVisible(false)}
            footer={false}
            className="modal__settings"
            mask={false}
            title="Paramètre"
        >
            <p>Vous pouvez à partir de ce menu modifier l'état de votre statut en ligne.</p>
            {status && <small style={{ color: "red" }}>En ayant le statut "Occupé" vous ne recevrez plus les notifications à l'affichage n'y les notifications sonores.</small>}
            <fieldset>
                <legend>
                    Statut
                </legend>
                <Switch checkedChildren="En ligne" onChange={handleChangeStatus} unCheckedChildren="Occupé" defaultChecked={store.getState().user?.data?.statusOnline === "online" ? true : false} />
            </fieldset>
        </Modal>
        <Header className="nav-bar-header">
            <Link to="/global"><img src="https://chatelainxpert.be/img/logo.svg" alt="logo" style={{ width: '60%', position: 'relative' }} /></Link>
            {user?.data?.isLogged && <div className="user-action">
                <div className="wrapped-element-user">
                    <Dropdown overlay={notification} arrow trigger={['click']}>
                        <Badge count={tchat?.data?.count + tchat?.data?.notification?.unread}>
                            <BellFilled className="bell-button" />
                        </Badge>
                    </Dropdown>
                    <Dropdown overlay={menu} arrow trigger={['click']}>
                        <Avatar size="large" src={user?.data?.avatar || ""} style={{ background: 'rgba(' + user?.data?.defaultColor + ')', textTransform: 'uppercase' }}>
                            {user?.data?.name?.length > 1 ? user.data.name.substring(0, user.data.name.length - (user.data.name.length - 1)) : user.data.name}
                        </Avatar>
                    </Dropdown>
                </div>
            </div>}
        </Header>
    </>)
}

const mapStateToProps = ({ user, tchat, app }) => ({ user, tchat, app })
const mapDispatchToProps = dispatch => ({ dispatch })

export default _.compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(HeaderLayout);